<label class="email-notifications-setting">
  <input
    type="checkbox"
    [formControl]="control()"
    [attr.aria-describedby]="'email-notifications-hint'"
  />
  <span class="email-notifications-setting__copy">
    <span class="email-notifications-setting__label">
      {{ 'app.components.profileSettings.emailNotificationsLabel' | translate }}
    </span>
    <span id="email-notifications-hint" class="email-notifications-setting__hint">
      {{ 'app.components.profileSettings.emailNotificationsHint' | translate }}
    </span>
  </span>
</label>
